import { createFileRoute } from "@tanstack/react-router";
import StatisticiAuto from "@/pages/StatisticiAuto";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/auto-statistiken/")({
  head: () => routeHead("/de/auto-statistiken/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <StatisticiAuto />
  );
}
